import { render, staticRenderFns } from "./profile-subscription-category-details.vue?vue&type=template&id=6d1dfcea&scoped=true&"
import script from "./profile-subscription-category-details.ts?vue&type=script&lang=ts&"
export * from "./profile-subscription-category-details.ts?vue&type=script&lang=ts&"
import style0 from "./profile-subscription-category-details.scss?vue&type=style&index=0&id=6d1dfcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1dfcea",
  null
  
)

export default component.exports